<template>
	<div class="pages" :style="{ height: height + 'px' }">
		<navTop></navTop>
		<div class="box">
			<div v-for="(item,index) in datalist" class="box-li" @click="goProgress(item,type)">
				<p>{{item.name}}</p>
				<img src="../../assets/left.png" />
			</div>

		</div>
	</div>
</template>

<script>
import navTop from '../../components/navTop.vue';
export default {
	name: 'list',
	components: {
		navTop
	},
	data() {
		return {
			height: '',
			id: '',
			type: '',
			datalist:[],
			name:'',
			xiazai:false
		};
	},
	created() {
		if (!sessionStorage.getItem('uid')) {
			this.$router.push({ path: '/' });
		} else {
			this.id = this.$route.query.id;
			this.type = this.$route.query.type;
			this.height = window.innerHeight;
			this.name=this.$route.query.name;
			this.xiazai=this.$route.query.xiazai;
			console.log(this.$route.query.type,'this.$route.query.type')
			// if(!this.$route.query.xiazai){
				switch(this.$route.query.type){
					case '1':
					return this.addarr(this.$route.query.type)
					case '2':
					return this.addarr(this.$route.query.type)
				}
			// }

		}
		console.log(this.id,'this.id')
	},
	methods:{
		setarr(data){
			for(let i=0; i<data.length;i++){
				let arr={
					name:this.name+' '+(i+1),
					id:data[i].id
				}
				this.datalist.push(arr)
			}
		},
		addarr(num){
			if(num=='2'){
				this.$api.Dailyreport({id:this.id}).then((res)=>{
					console.log(res,'ffff')
					this.setarr(res.data)
				})
			}
			if(num=='1'){
				this.$api.khblist({id:this.id}).then((res)=>{
					this.setarr(res.data)
					console.log(res,'ffff')

				})
			}

		},
		goProgress(e,type){
			console.log(e,type)
			// this.$router.push({ path: '/rb', query: { id: this.id,scheduleId:e.id } });
			if(!this.xiazai){
				switch(type){
					case '1':
					return this.$router.push({ path: '/khb', query: { id: this.id,scheduleId:e.id  } });
					case '2':
					return this.$router.push({ path: '/rb', query: { id: this.id,scheduleId:e.id } });
				}
			}else{
				window.open('http://39.105.212.82/userfiles/null/fj/reportImg/' + e.id + '.pdf')
			}

		}
	}

	}

</script>

<style lang="scss" scoped>
.pages {
	background: #3E414A;
	.box {
		width: 100%;
		margin: 0 auto;
		padding-top: 109px;
		box-sizing: border-box;
		.box-li {
			width: 100%;
			height: 100px;
			border: 1px solid rgba(0, 255, 255, 0.25);
			border-radius: 10px;
			background: #053134;
			margin-bottom: 28px;
			padding: 0 55px;
			box-sizing: border-box;
			display: flex;
			align-items: center;
			justify-content: space-between;
			p {
				font-size: 30px;
				color: #1bf6ff;
				line-height: 1em;
			}
			img {
				width: 23px;
				height: 41px;
				display: block;
			}
		}
		.box-li:last-child {
			margin: 0;
		}
	}
}
</style>
